<template>
    <Forms ref="frmSearch"
            title="INFORMAÇÕES"
            :showHelp="false"
            :showClearButton="false"
            :showSearchButton="false"
            :showNewButton="false"
            :ShowFooterImbo="false"
            :showEdit="true"
            style="font-family: 'Segoe UI';"
            >
        <div class="aprDetails">
            <div class="title-apr">Informações PIT</div>
            <div class="info-title">
                <div class="group-info">
                    <div class="status">
                        <div class="subtitle">
                            Status
                        </div>
                        <div :class="qma.statusQma === 0 ? 'status-pill-wip' : qma.statusQma === 1 ? 'status-pill-waiting' :  qma.statusQma === 2 ?
                                'status-pill-aproved' : 'status-pill-reproved'">{{ qma.statusQMADescricao }}
                        </div>
                    </div>
                    <div class="info-date">
                        <div>
                            <div class="subtitle">Data Início</div>
                            <div class="mt-2">{{ qma.dataInicioFormatada }}</div>
                        </div>
                        <div>
                            <div class="subtitle">Data Fim</div>
                            <div class="mt-2">{{ qma.dataTerminoFormatada }}</div>
                        </div>
                        <!-- <div>
                            <div class="subtitle">Data Final</div>
                            <div class="mt-2">{{ propQma.dataValidadeAPRFormatada }}</div>
                        </div> -->
                    </div>
                </div>
                <div>
                    <div class="subtitle">Serviços</div>
                    <div class="mt-2">{{ qma.servicos }}</div>
                </div>
            </div>
            <div>
                <div class="mt-2">
                    <div class="info-construction">Informações da Obra</div>
                    <div>
                        <div class="construction-group-info">
                            <div class="mr-3">
                                <div class="subtitle">Código da Obra</div>
                                <div class="mt-2">{{ qma.obraCod }}</div>
                            </div>
                            <div>
                                <div class="subtitle">Obra</div>
                                <div class="mt-2">{{ qma.obraNom }}</div>
                            </div>
                        </div>
                        <div class="construction-group-info">
                            <div>
                                <div class="subtitle">Local</div>
                                <div class="mt-2">{{qma.obraLocal}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-3">
                    <div class="info-responsible">Responsável</div>
                    <div class="responsable-group-info">
                        <div>
                            <div class="subtitle">Colaborador</div>
                            <div class="mt-2">{{ qma.responsavel !== null? qma.responsavel : 'N/D' }}</div>
                        </div>
                        <div>
                            <div class="subtitle">Matrícula</div>
                            <div class="mt-2">{{ qma.matricula }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="aprRep mt-2">
                <div class="btnAprRep"
                     v-if="qma.engenheiroAprovadorId || qma.coordenadorAprovadorId || (qma.statusQma == 1 && (hasRole(roles.QMA_RESEARCH_TECHNICAL_ENGINEER_VIEW) || hasRole(roles.QMA_COORDINATOR_APPROVAL) || hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL)))">
                    <div v-if="qma.engenheiroAprovadorId" class="approval-chip">
                        <i class="fas fa-check-circle approval-chip-check"></i>
                        <div class="approval-chip-info">
                            <div class="approval-chip-label">ENGENHEIRO</div>
                            <div class="approval-chip-name">{{ qma.engenheiroNome || '—' }}</div>
                            <div class="approval-chip-date" v-if="qma.engenheiroDataAprovacao">{{ formatarDataAprovacao(qma.engenheiroDataAprovacao) }}</div>
                        </div>
                    </div>
                    <button
                        v-else-if="qma.statusQma == 1 && (hasRole(roles.QMA_RESEARCH_TECHNICAL_ENGINEER_VIEW) || hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL))"
                        class="btn-appr"
                        @click="PopUpQmaRepForm('engenheiro')"
                    >
                        Aprovar como Engenheiro
                    </button>

                    <div v-if="qma.coordenadorAprovadorId" class="approval-chip">
                        <i class="fas fa-check-circle approval-chip-check"></i>
                        <div class="approval-chip-info">
                            <div class="approval-chip-label">COORDENADOR</div>
                            <div class="approval-chip-name">{{ qma.coordenadorNome || '—' }}</div>
                            <div class="approval-chip-date" v-if="qma.coordenadorDataAprovacao">{{ formatarDataAprovacao(qma.coordenadorDataAprovacao) }}</div>
                        </div>
                    </div>
                    <button
                        v-else-if="qma.statusQma == 1 && (hasRole(roles.QMA_COORDINATOR_APPROVAL) || hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL))"
                        class="btn-appr"
                        @click="PopUpQmaRepForm('coordenador')"
                    >
                        Aprovar como Coordenador
                    </button>

                    <button
                        v-if="qma.statusQma == 1 && (!qma.engenheiroAprovadorId || !qma.coordenadorAprovadorId) && (hasRole(roles.QMA_RESEARCH_TECHNICAL_ENGINEER_VIEW) || hasRole(roles.QMA_COORDINATOR_APPROVAL) || hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL))"
                        class="btn-rep"
                        @click="PopUpQmaRepForm('reprovar')"
                    >
                        REPROVAR
                    </button>
                </div>
                <!-- Só o QMA - Administrador desfaz aprovação/reprova (chamado #20155, item 10). Fica
                     fora do btnAprRep porque aquele bloco some no reprovado sem aprovador. -->
                <div class="btnAprRep" v-if="(qma.statusQma == 2 || qma.statusQma == -1) && hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL)">
                    <button class="btn-rep" @click="$refs['popupVoltarStatus'].show()">
                        VOLTAR STATUS
                    </button>
                </div>
                <b-modal ref="popupVoltarStatus"
                  size="md"
                  centered
                  :hide-footer="true"
                  :no-close-on-backdrop="true"
                  body-class="rounded-bottom-1rem"
                  content-class="rounded-1rem"
                  >
                  <template #modal-title>
                    <div class="header-title">Voltar status</div>
                  </template>
                  <div class="popUpAprRepBody">
                    <div class="mt-2 font" style="text-align: center;">
                      O {{ qma.numeroQma }} está {{ qma.statusQma == 2 ? 'APROVADO' : 'REPROVADO' }} e vai voltar para AG. APROVAÇÃO.
                      {{ qma.statusQma == 2 ? 'As aprovações registradas serão desfeitas.' : '' }} A ação fica registrada no histórico.
                    </div>
                  </div>
                  <div class="container-buttons-form pt-3">
                    <button class="button-rep" @click="voltarStatus">VOLTAR STATUS</button>
                    <button class="button-cancel" @click="$refs['popupVoltarStatus'].hide()">Fechar</button>
                  </div>
                </b-modal>
            </div>
            <b-modal ref="popupAprRep"
            size="md"
              centered
              :hide-footer="true"
              :no-close-on-backdrop="true"
              :no-close-on-esc="true"
              body-class="rounded-bottom-1rem"
              content-class="rounded-1rem"
              >
              <template #modal-title>
                <div class="header-title">
                  {{ approvalAction === 'reprovar' ? 'Motivo da Reprova' : approvalAction === 'engenheiro' ? 'Aprovar como Engenheiro' : 'Aprovar como Coordenador' }}
                </div>
              </template>
            <div class="popUpAprRepBody" v-if="approvalAction !== 'reprovar'">
                <i class="fas fa-check icon-aprRep" style="scale: 2.5; background-color: #008148;"></i>
                <div class="d-flex mt-2">
                  Deseja {{ approvalAction === 'engenheiro' ? 'aprovar como Engenheiro' : 'aprovar como Coordenador' }} o {{ qma.numeroQma }}?
                </div>
              </div>
              <div class="popUpAprRepBody" style="height:15rem" v-else>
                <b-form-group
                  class="font"
                  id="Input-group-template"
                  label="Motivo da Reprova"
                  label-for="input-template"
                >
                <b-form-textarea
                style="height: 10rem;"
                  id="textarea"
                  v-model="motivoReprova"
                  placeholder="Descreva o motivo da reprova"
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
                </b-form-group>
              </div>
              <div class="container-buttons-form pt-3">
                <button v-if="approvalAction !== 'reprovar'" class="button-save" @click="AproveReprove(true)">CONFIRMAR</button>
                <button v-else class="button-rep" @click="AproveReprove(false, motivoReprova)">REPROVAR</button>
                <button class="button-cancel" @click="closeQmaAprRep">Fechar</button>
              </div>
        </b-modal>
        <b-modal ref="confirmForm"
            size="md"
            centered
            id="add-edit-form"
            :hide-footer="true"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            :hide-header=" true"
            body-class="rounded-1rem"
            content-class="rounded-1rem"
            >
              <div class="popUpAprRepBody">
                <i class="fas fa-check icon-aprRep" style="scale: 2.5; background-color: #008148;"></i>
                <div class="d-flex">
                  Pit {{ qma.numeroQma }} {{ approvalAction === 'reprovar' ? 'reprovado' : 'aprovado' }} com sucesso!
                </div>
              </div>
              <div class="container-buttons-form pt-3">
                <button class="button-cancel" @click="confirmPopUp">Fechar</button>
              </div>
        </b-modal>
        </div>
    </Forms>
    </template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'
import { loading, toast } from '@/shared/utils/UIHelper'
// import AprAnalisePreliminarRisco from '@/shared/http/repositories/business/aprInquery'
import inqueryQmaRepository from '@/shared/http/repositories/business/qmaInquery'

export default {
  name: 'informationQmaPivs',
  components: {AutocompleteZ},
  mixins: [ ActionsForm, ExpenseMixin ],
  props: ['propQma', 'editDetails'],
  data () {
    return {
      form: {
        ResponsavelId: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      },
      QmaID: null,
      apr: [],
      qma: {},
      isApprove: false,
      motivoReprova: '',
      approvalAction: null
    }
  },
  watch: {
    'editDetails': function (newValue) {
      this.propQma.refereciaObra = newValue.refereciaObra
      this.propQma.local = newValue.local
    }
  },
  async mounted () {
  },
  methods: {
    Search () {
    },
    onClearSection () {
    },
    async onLoad () {
      const params = new URLSearchParams(window.location.search)
      params.forEach((value) => {
        this.QmaID = value
      })
      loading.push()
      await inqueryQmaRepository.GetInfo(this.QmaID)
        .then((Response) => {
          loading.pop()
          this.qma = Response.data.data[0]
        })
        .catch((err) => {
          console.log(err)
        })
    },
    PopUpQmaRepForm (action) {
      this.approvalAction = action
      this.isApprove = (action !== 'reprovar')
      this.motivoReprova = ''
      this.$refs['popupAprRep'].show()
    },
    closeQmaAprRep () {
      this.motivoReprova = ''
      this.$refs['popupAprRep'].hide()
    },
    substituirBarras (texto) {
      return texto.replace(/[/\\]/g, '-')
    },
    formatarDataAprovacao (date) {
      if (!date) return '-'
      return new Date(date).toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    },

    AproveReprove (value, obj) {
      loading.push()
      if (this.approvalAction === 'reprovar') {
        const motivoreprova = obj
        if (motivoreprova === null || motivoreprova === undefined || motivoreprova === '') {
          loading.pop()
          return toast.warning('Campo não pode ser nulo!')
        }
        const motivoFinal = this.substituirBarras(motivoreprova)
        inqueryQmaRepository.ReprovarQMA(this.QmaID, motivoFinal)
          .then(() => {
            loading.pop()
            this.$refs['popupAprRep'].hide()
            this.$refs['confirmForm'].show()
            this.$emit('Reload')
          })
          .catch((err) => {
            loading.pop()
            console.log(err)
          })
      } else if (this.approvalAction === 'engenheiro') {
        inqueryQmaRepository.AprovarEngenheiro(this.QmaID)
          .then(() => {
            loading.pop()
            this.$refs['popupAprRep'].hide()
            this.$refs['confirmForm'].show()
            this.$emit('Reload')
          })
          .catch((err) => {
            loading.pop()
            console.log(err)
          })
      } else {
        inqueryQmaRepository.AprovarCoordenador(this.QmaID)
          .then(() => {
            loading.pop()
            this.$refs['popupAprRep'].hide()
            this.$refs['confirmForm'].show()
            this.$emit('Reload')
          })
          .catch((err) => {
            loading.pop()
            console.log(err)
          })
      }
    },
    voltarStatus () {
      loading.push()
      inqueryQmaRepository.VoltarStatusQMA(this.QmaID)
        .then(() => {
          loading.pop()
          this.$refs['popupVoltarStatus'].hide()
          toast.success('Status voltou para AG. APROVAÇÃO.')
          this.$emit('Reload')
        })
        .catch((err) => {
          loading.pop()
          toast.error(err.response && err.response.data ? err.response.data : 'Não foi possível voltar o status.')
        })
    },
    confirmPopUp () {
      this.$refs['confirmForm'].hide()
    }
  }
}

</script>

<style scoped>
  .font {
    width: 100%;
    font-family: 'Segoe UI';
    font-size: 14px;
    font-weight: bold;
    color: #505050;
  }
  .header-title{
    color: white;
    font-weight: bold;
    font-size: 16px;
    font-family: 'Segoe UI';
  }
.aprRep{
    /* coluna: aprovações (chips/botões) e o VOLTAR STATUS empilhados, não lado a lado */
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
}
.btnAprRep{
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    align-items: stretch;
    width: 60%;
}
.approval-chip {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    background: #F1F9F4;
    border: 1px solid #BFE3CC;
    border-radius: 6px;
    color: #1A1818;
    font-family: 'Segoe UI';
}
.approval-chip-check {
    color: #008148;
    font-size: 1.5rem;
    flex-shrink: 0;
}
.approval-chip-info {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
    line-height: 1.2;
}
.approval-chip-label {
    font-size: 11px;
    font-weight: bold;
    color: #008148;
    letter-spacing: 0.05em;
}
.approval-chip-name {
    font-size: 14px;
    font-weight: 600;
}
.approval-chip-date {
    font-size: 12px;
    color: #5C6066;
}
.btn-rep-wrapper {
    display: flex;
    justify-content: flex-end;
    margin-top: 0.25rem;
}
.btn-rep-link {
    background: transparent;
    border: none;
    color: #C0392B;
    font-size: 13px;
    font-weight: 500;
    font-family: 'Segoe UI';
    padding: 0.25rem 0.5rem;
    cursor: pointer;
    text-decoration: underline;
}
.btn-rep-link:hover {
    color: #7D1F15;
    text-decoration: none;
}
.btn-rep-link i {
    margin-right: 0.25rem;
}
.btn-rep{
    background-color: red;
    color: #ffffff;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    height: 40px;
    width: 100%;
  }
.btn-appr{
    background-color: #008144;
    color: #ffffff;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    height: 40px;
    width: 100%;
  }
  .btn-rep:hover{
    background-color: rgb(179, 1, 1);
    color:#ffffff;
  }
.btn-appr:hover{
    background-color: #01532d;
    color:#ffffff;
  }
.btn-appr:disabled {
    background-color: #5a9e6e;
    cursor: default;
    opacity: 0.85;
}
.approval-progress {
    order: 1;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 0 !important;
}
.approval-badge {
    display: inline-flex;
    font-size: 12px;
    font-weight: bold;
    font-family: 'Segoe UI';
}
.badge-waiting-both, .badge-waiting-eng, .badge-waiting-coord {
    color: #003789;
    background: transparent;
}
.aprDetails{
    display: flex;
    gap: 1rem;
    flex-direction: column;
    flex-wrap: wrap;
}
.title-apr, .info-construction, .info-responsible{
    color: #008148;
    font-family: "Segoe UI";
    font-weight: bold;
    font-size: 16px;
}
.info-responsible{
    display: flex;
}
.responsable-group-info, .construction-group-info{
    margin-top: 1rem;
    display: flex;
    gap: 1rem;
}
.subtitle{
    width: 100%;
    color: #9AA2A4;
    font-size: 14px;
    font-family: "Segoe UI";
}
.status {
    width: 50%
}
.status-pill-wip{
    display: flex;
    font-size: 14px !important;
    padding: 1rem;
    width: fit-content;
    height: 30px;
    color: #6a6a6a;
    font-weight: bold;
    font-family: 'Segoe UI';
    justify-content: center;
    padding-left: 10%;
    padding-right: 10%;
    border-radius: 25px;
    align-items: center;
    background: #c0c0c0;
}
.status-pill-aproved {
    display: flex;
    font-size: 14px !important;
    padding: 1rem;
    width: fit-content;
    height: 30px;
    color: #133B1A;
    font-weight: bold;
    font-family: 'Segoe UI';
    justify-content: center;
    padding-left: 10%;
    padding-right: 10%;
    border-radius: 25px;
    align-items: center;
    background: #CBE9CF;
}
.status-pill-waiting {
    display: flex;
    font-size: 14px !important;
    padding: 1rem;
    width: fit-content;
    height: 30px;
    color: #003789;
    font-weight: bold;
    font-family: 'Segoe UI';
    justify-content: center;
    padding-left: 10%;
    padding-right: 10%;
    border-radius: 25px;
    align-items: center;
    background: #D4EEFD;
}
.status-pill-reproved {
    display: flex;
    font-size: 14px !important;
    padding: 1rem;
    width: fit-content;
    height: 30px;
    color: #AB0101;
    font-weight: bold;
    font-family: 'Segoe UI';
    justify-content: center;
    padding-left: 10%;
    padding-right: 10%;
    border-radius: 25px;
    align-items: center;
    background: #FFD9D9;
}
.info-title {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}
.popUpAprRepBody{
      padding: 1rem;
      display: flex;
      align-items: center;
      flex-direction: column;
      gap: 1rem;
    }
.container-buttons-form{
    display: flex;
    justify-content: center;
    align-items: center;
    gap:15px;
    flex-direction: column;
  }
.button-cancel,.button-save, .button-rep{
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 190px;
    height: 40px;
  }
  .button-cancel{
    background-color: #dedede;
    color: #747474;
  }
  .button-save{
    background-color: #008148;
    color: white;
  }
  .button-rep {
    background-color: #b60000;
    color: white;
}
  .icon-aprRep{
    color: white;
    padding: 2.5px;
    border-radius:50%
  }
  .icon-times {
    border-radius: 50%;
    width: 1.5rem;
    height: 1.5rem;
    display: flex;
    align-content: center;
    justify-content: center;
    flex-wrap: wrap;
    color: white;
  }
@media (min-width: 390px) {
    .status {
        width: 100%;
    }
    .info-date {
        display: flex;
        gap: 1rem;
    }
}

@media (min-width: 1400px) {
    .status {
        width: 50%;
    }
    .info-title {
        display: flex;
        gap: 1rem;
    }
    .info-date {
        display: flex;
        gap: 2rem;
    }
    .group-info{
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/private/qma/inqueryQma/inqueryQmaPit/components/inqueryQmaPitTable/components/inqueryQmaPitDetails/components/inqueryDetailsInformationQmaPit/inqueryDetailsInformationQmaPit.vue